 import { Routes } from '@angular/router';
import {PanelLayout} from './panel-layout/panel-layout';
import {statementsRoutes} from './statements/statements.route';
import {usersRoutes} from './users/users.route';
import { paymentsRoutes } from './payments/payments.route';
import { dashboardRoutes } from './dashboard/dashboard.route';
import { announcementsRoutes } from './announcements/communications.route';
import { contractsRoutes } from './contracts/contracts.route';
import { NotFound } from './not-found/not-found';
import { Forbidden } from './forbidden/forbidden';
import { hasPermissionGuard } from '../../guards/has-permission-guard';
import { permissionsRoutes } from './permissions/permissions.route';
import { reportsRoutes } from './reports/reports.route';
import { MARKET_ROUTES } from './market/market.route';
import { TELEMARKETING_ROUTES } from './telemarketing/telemarketing.route';
import { UTM_BETTORS_ROUTES } from './utm-bettors/utm-bettors.route';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { LayoutService } from '../../services/layout.service';

export const panelRoute: Routes = [
  {
    path: '',
    loadComponent: () => PanelLayout,
    children: [
      { path: 'dashboard', loadChildren: () => dashboardRoutes, canActivate: [hasPermissionGuard], data: { permission: 'view dashboard' } },
      { path: 'reports', loadChildren: () => reportsRoutes },
      { path: 'market', loadChildren: () => MARKET_ROUTES, canActivate: [hasPermissionGuard], data: { permission: ['view market', 'view reports cohort'] } },
      { path: 'telemarketing', loadChildren: () => TELEMARKETING_ROUTES, canActivate: [hasPermissionGuard], data: { permission: 'view telemarketing' } },
      { path: 'utm-bettors', loadChildren: () => UTM_BETTORS_ROUTES, canActivate: [hasPermissionGuard], data: { permission: 'get utm bettors' } },
      { path: 'statements', loadChildren: () => statementsRoutes, canActivate: [hasPermissionGuard], data: { permission: 'view statements' } },
      { path: 'payments', loadChildren: () => paymentsRoutes, canActivate: [hasPermissionGuard], data: { permission: 'view payments' } },
      { path: 'contracts', loadChildren: () => contractsRoutes, canActivate: [hasPermissionGuard], data: { permission: 'view contracts' } },
      { path: 'announcements', loadChildren: () => announcementsRoutes, canActivate: [hasPermissionGuard], data: { permission: 'view announcements' } },
      { path: 'users', loadChildren: () => usersRoutes, canActivate: [hasPermissionGuard], data: { permission: 'view users' } },
      { path: 'permissions', loadChildren: () => permissionsRoutes, canActivate: [hasPermissionGuard], data: { permission: 'view roles' } },
      {
        path: 'not-found',
        loadComponent: () => NotFound,
        title: async () => {
          const title = await firstValueFrom(inject(LayoutService).systemTitle$);
          return `${title} - Página não encontrada`;
        }
      },
      {
        path: 'forbidden',
        loadComponent: () => Forbidden,
        title: async () => {
          const title = await firstValueFrom(inject(LayoutService).systemTitle$);
          return `${title} - Acesso negado`;
        }
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ]
  },
];
